import { useContext, useMemo } from 'react'
import { Link as RouterLink } from 'react-router'
import { Home } from '@mui/icons-material'
import { Breadcrumbs, Grid, Link } from '@mui/material'

import { AppContext } from '../../providers/app-provider'

import useStyles, { useMinimizedBreadcrumbStyles } from './index.styles'

const BreadcrumbsComponent = ({ folderId, minimized }: { folderId: number | undefined; minimized?: boolean }) => {
  const classes = useStyles
  const minimizedBreadcrumbClasses = useMinimizedBreadcrumbStyles
  const { tree, treeRoots, tenantId } = useContext(AppContext)

  const folderParents = useMemo(() => {
    if (!folderId) return []
    if (!tree) return []
    if (!tree?.[folderId]) return []

    const parents: (IFolderTreeItem & { id: number })[] = []
    let currentId: number | undefined = folderId
    while (currentId && tree[currentId]) {
      if (currentId !== folderId)
        parents.unshift({
          id: currentId,
          ...tree[currentId],
        })
      currentId = tree[currentId].parentId
    }

    return parents
  }, [tree, folderId])

  return (
    <Grid>
      <Breadcrumbs sx={minimized ? minimizedBreadcrumbClasses : {}}>
        <Link component={RouterLink} to="/accounts" underline="hover" sx={classes.breadcrumbLink} aria-label="View All Accounts">
          <Home sx={classes.bannerHomeIcon} />
        </Link>
        {folderParents.length > 0 &&
          folderParents.map((parent) => (
            <Link
              key={parent.id}
              component={RouterLink}
              to={treeRoots.length === 1 && parent.id === treeRoots[0] ? '/accounts' : `/tenant/${tenantId}/accounts/${parent.id}`}
              underline="hover"
              className="fs-exclude"
              sx={classes.breadcrumbLink}
              data-testid="breadcrumb-link"
            >
              {parent.name}
            </Link>
          ))}
      </Breadcrumbs>
    </Grid>
  )
}

export default BreadcrumbsComponent
